import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { Button } from '@ssml-editor/vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "redo-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    function menuClickHandler() {
      if (__props.editor) {
        __props.editor.redo();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-chongzuo",
        onClick: menuClickHandler
      }, {
        default: withCtx(() => [
          createTextVNode("重做")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=redo-menu.vue.js.map
